/* Consumer hook for the guided walkthrough context. Throws if used outside provider. */

import { useContext } from "react";
import {
  GuidedWalkthroughContext,
  type GuidedWalkthroughContextValue,
} from "@/contexts/guidedWalkthroughContextValue";

export function useGuidedWalkthroughContext(): GuidedWalkthroughContextValue {
  const ctx = useContext(GuidedWalkthroughContext);
  if (!ctx) {
    throw new Error(
      "useGuidedWalkthroughContext must be used within a GuidedWalkthroughProvider",
    );
  }
  return ctx;
}
